import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// LocalStorage key for persisting selected team
export const SELECTED_TEAM_KEY = 'team-rid';

export interface TeamMemberState {
    /** The current person's RID - used for API headers */
    personRid?: string;
    selectedTeamRid?: string;
}

const initialState: TeamMemberState = {
    selectedTeamRid: undefined,
    personRid: undefined,
};

const teamMemberSlice = createSlice({
    name: 'teamMember',
    initialState,
    reducers: {
        setPersonRid: (state, action: PayloadAction<string | undefined>) => {
            state.personRid = action.payload;
        },
        setSelectedTeamRid: (state, action: PayloadAction<string | undefined>) => {
            state.selectedTeamRid = action.payload;
        },
    },
    selectors: {
        selectCurrentTeamRid: (teamMemberState: TeamMemberState) => teamMemberState.selectedTeamRid,
        selectPersonRid: (teamMemberState: TeamMemberState) => teamMemberState.personRid,
    },
});

export const { setSelectedTeamRid, setPersonRid } = teamMemberSlice.actions;
export const { selectCurrentTeamRid, selectPersonRid } = teamMemberSlice.selectors;

export default teamMemberSlice.reducer;
